"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidelineButton = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const guideline_button_styles_1 = require("./guideline-button.styles");
const icons_1 = require("../../../icons");
const GuidelineButton = ({ tooltipText, color = 'primary', onClick }) => (react_1.default.createElement(ui_components_1.ToolTip, { arrow: true, placement: "top", title: tooltipText }, react_1.default.createElement(guideline_button_styles_1.StyledIconButton, { size: "small", color: color, onClick: onClick }, react_1.default.createElement(icons_1.LogIcon, { fontSize: "small" }))));
exports.GuidelineButton = GuidelineButton;
exports.default = exports.GuidelineButton;
